/**
 * Single source of truth for "is this a production build".
 *
 * The value is resolved from VITE_ENV in vite.config and injected as a literal, for two reasons.
 * VITE_ENV is what the CI already passes as a Docker build arg, unlike Vite's own PROD flag, which is
 * true for any `vite build` and so cannot tell the production image apart from the staging one. And
 * because the flag is a literal rather than a runtime lookup, the bundler folds the branches that
 * depend on it, so debug-only code is removed from the production bundle instead of just skipped.
 *
 * Being independent of the hostname, a production build also behaves like production when it is
 * served from localhost for testing (see the build:prod script).
 */
export const IS_PRODUCTION_BUILD = __IS_PRODUCTION_BUILD__

/** Debug panel, FPS meter, Pixi inspector and console output all hang off this. */
export const IS_DEBUG_BUILD = !IS_PRODUCTION_BUILD
